import * as React from 'react';
import {
  INTERNAL_SUPPORTED_EVENTS,
  PLUGIN_SUPPORTED_EVENTS,
} from '~/common/helpers';
import { useLogger } from '~/common/context';

export const usePluginEventHandlers = () => {
  const logger = useLogger();
  const getEventHandler = React.useCallback(
    (eventName: string): EventListener | null => {
      switch (eventName) {
        case PLUGIN_SUPPORTED_EVENTS.RELOAD_CUSTOMER:
          return () => {
            logger.info(
              `Plugin Event: ${PLUGIN_SUPPORTED_EVENTS.RELOAD_CUSTOMER} triggered`,
            );
            window.dispatchEvent(
              new CustomEvent(INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER),
            );
          };
        default:
          return null;
      }
    },
    [logger],
  );

  return {
    getEventHandler,
  };
};
